//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { observer, Observer } from "mobx-react-lite";
import React, { Component } from "react";
import TutorRequestPool from "./TutorRequestPool";

class RequestPoolComponent extends Component<any, any> {
  state: any = {};
  handleToggleTutorApproval = (approval) => {
    this.setState({ loading: true });
    let { toggleTutorApprovalFunc } = this.props;
    toggleTutorApprovalFunc(this.props.poolId, approval, this);
  };

  handleUpdateTutorPrice = (event) => {
    event.preventDefault();
    this.setState({ loading: true, typing: false });
    if (event.target.price.value < 0) {
      this.setState({ typing: true, loading: false });
      this.props.updateMsg(true, "Enter a positive value", true);
    } else if (event.target.price.value === this.state.cost) {
      this.setState({ typing: true, loading: false });
      this.props.updateMsg(true, "Modify tutor's current price", true);
    } else {
      this.props.updateTutorPrice(
        event.target.price.value,
        this.props.poolId,
        this,
      );
      // this.updateTutorPrice(event.target.price.value);
    }
  };

  handleChangeDefaultSubject = (event) => {
    this.setState({ loading: true });
    this.props.changeDefaultSubject(
      event.target.value,
      this.props.poolId,
      this,
    );
  };

  // changeDefaultSubject(subject_name) {
  //   sendToServer(
  //     `admin/request-pool/${this.props.poolId}/update-details/`,
  //     "POST",
  //     { default_subject: subject_name },
  //     "updateDefaultSubject",
  //     this,
  //     null,
  //     this.props.updateMsg
  //   );
  // }

  toggleUpdateBtn = (value) => {
    this.setState({ typing: value });
  };

  toggleTutorDetail = () => {
    this.setState({ showDetail: !this.state.showDetail });
  };

  // updateTutorPrice(price) {
  //   sendToServer(
  //     `admin/request-pool/${this.props.poolId}/update-details/`,
  //     "POST",
  //     { cost: price },
  //     "updatePrice",
  //     this,
  //     null,
  //     this.props.updateMsg
  //   );
  // }
  componentWillMount() {
    this.setState({
      approved: this.props.approved,
      defaultSubject: this.props.defaultSubject,
      cost: this.props.cost,
      message: { status: false, text: "" },
      typing: false,
      loading: false,
      showDetail: false,
    });
  }
  render() {
    let component = this;
    return (
      <TutorRequestPool
        poolId={this.props.poolId}
        component={component}
        store={this.props.store}
        loading={this.state.loading}
        typing={this.state.typing}
        showDetail={this.state.showDetail}
        key={this.props.poolId}
        tutorName={this.props.tutorName}
        tutorEmail={this.props.tutorEmail}
        tutorPhoneNo={this.props.tutorPhoneNo}
        tutorAddress={this.props.tutorAddress}
        cost={this.state.cost}
        defaultSubject={this.state.defaultSubject}
        matchedSubjects={this.props.matchedSubjects}
        approved={this.state.approved}
        teachesAll={this.props.teachesAll}
        updateMsg={this.props.updateMsg}
        toggleUpdateBtn={this.toggleUpdateBtn}
        toggleTutorDetail={this.toggleTutorDetail}
        handleUpdateTutorPrice={this.handleUpdateTutorPrice}
        handleChangeDefaultSubject={this.handleChangeDefaultSubject}
        handleToggleTutorApproval={this.handleToggleTutorApproval}
      />
    );
  }
}

export default RequestPoolComponent;
